//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import AUbutton from '@gov.au/buttons';
import { AUcallout } from '@gov.au/callout';
import AUpageAlert from '@gov.au/page-alerts';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import queryString from 'query-string';
import UAParser from 'ua-parser-js';

//Components
import Heading from '../components/CASA/Heading';
import RPAList from '../components/Portal/RPAList';
import CASASpinner from '../components/Portal/CASASpinner';
import Container from '../components/CASA/Container';
import CasaModal from '../components/CASA/CasaModal';

//Actions
import { getUserHomePage, UserMustVerifyPOI, UserMustSubmitIndividualARNApplication, getParamValue, urlSearchValue, getPortalUrl, isUUID } from '../components/Portal/Utilities';
import { getExpirySelector, getFeatureSelector, getUrlSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getDroneCrmReferenceData, FETCH_CRMREFERENCEDATA_SUCCESS } from '../FormStore/Actions/CRMReferenceDataActions';
import { deleteDraftASF, DELETE_DRAFT_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/DeleteDraftAction';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getOrganisationDetails, FETCH_ORGANISATIONDETAILS_SUCCESS } from '../PortalStore/Actions/OrganisationDetailsActions';
import { getOrgDetailsSelector } from '../PortalStore/Selectors/OrgDetailsSelectors';
//Combine these actions into one when APIs for IND/ORG combination is ready
import { getAppsIndividual, FETCH_APPSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AppsIndividualActions';
import { getAppsOrganisation, FETCH_APPSORGANISATION_SUCCESS } from '../PortalStore/Actions/AppsOrganisationActions';
import { getDronesIndividual, FETCH_DRONESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/DronesIndividualActions'
import { getDronesOrganisation, FETCH_DRONESORGANISATION_SUCCESS } from '../PortalStore/Actions/DronesOrganisationActions';
import { hasDraftsIndividual, HAS_DRAFTSINDIVIDUAL_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/HasDraftsIndividualAction';
import { hasDraftsOrganisation, HAS_DRAFTSORGANISATION_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/HasDraftsOrganisationAction';

export const ManageRPAPage = () => {

    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoaded, setPageLoaded] = useState(false);
    const [showDelModal, setShowDelModal] = useState(false);
    const [deletingDraft, setDeletingDraft] = useState(false);
    const [draftRPAs, setDraftRPAs] = useState([]);
    const [iphone, setIphone] = useState(false);
    const [android, setAndroid] = useState(false);
    const [googleDownloadDone, setGoogleDownloadDone] = useState(false);
    const [appleDownloadDone, setAppleDownloadDone] = useState(false);
    const [modalActiveGoogle, setModalActiveGoogle] = useState(false);
    const [modalActiveApple, setModalActiveApple] = useState(false);
    const [showSpinnerFlag, setShowSpinnerFlag] = useState(false);

    //let googleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Google Accreditation'));
    //let appleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Apple Accreditation'));
    let organisationId = urlSearchValue('casaorgid') ?? getParamValue('organisationId')
    const isOrgPage = organisationId ? true : false

    const user = useSelector(state => state.userdetails.items?.value[0]);
    const B2CSettings = useSelector(state => state.B2CSettings.items);
    const googleUrl = useSelector(state => state.DownloadReplGoogle.items);
    const appleUrl = useSelector(state => state.DownloadReplApple.items);
    const organisationdetails = useSelector(state => state.organisationDetails);
    const userdetails = useSelector(state => state.userdetails);

    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);

    //Combine these variables into one when APIs for IND/ORG combination is ready
    //let certificatesIndividual = useSelector(state => state.certificatesIndividual);
    let dronesIndividual = useSelector(state => state.dronesIndividual);
    let appsIndividual = useSelector(state => state.appsIndividual);
    let draftsASFIndividual = useSelector(state => state.formStore.formServices.hasDraftsIndividual.items);
    //let certificatesOrganisation = useSelector(state => state.certificatesOrganisation);
    let dronesOrganisation = useSelector(state => state.dronesOrganisation);
    let appsOrganisation = useSelector(state => state.appsOrganisation);
    let draftsASFOrganisation = useSelector(state => state.formStore.formServices.hasDraftsOrganisation.items);

    let crmReferenceData = useSelector(state => state.crmReferenceData.referenceData)

    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));

    //let snippetCommFeeNoREOC = useSelector(state => getSnippetSelector(state, "CASA - Commercial Fee - NO REOC"));
    //let snippetCommFeeREOC = useSelector(state => getSnippetSelector(state, "CASA - Commercial Fee - REOC"));

    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));
 
    let featureAddDroneASF = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Add RPA Drone ASF"));
    let featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));

    var addDroneASFDate = moment(featureAddDroneASF, "DD/MM/YYYY");
    var addDroneASFAvailable = addDroneASFDate.isBefore();

    const weightList = crmReferenceData?.DRONE_WEIGHT_CLASS ?? []
    const maxWeightClassCode = weightList[weightList.length - 1]?.casa_code ?? ''

    let orgName = useSelector(state => getOrgDetailsSelector(state, "name"))
    let orgArn = useSelector(state => getOrgDetailsSelector(state, "casa_arn"))

    const name = isOrgPage ? orgName : user.fullname;
    //const arn = isOrgPage ? orgArn : userdetails.items.value[0].casa_arn;

    //const certificatesStored = isOrgPage ? certificatesOrganisation : certificatesIndividual
    const dronesStored = isOrgPage ? dronesOrganisation : dronesIndividual
    const appsStored = isOrgPage ? appsOrganisation : appsIndividual
    const draftsASFStored = isOrgPage ? draftsASFOrganisation : draftsASFIndividual

    //TODO: rpa pages need upgrading to use organisationid
    let jparams = isOrgPage ? {
        from: "org",
        organisationId: organisationId,
        organisationArn: orgArn,
        organisationName: orgName
    } : {
        from: "ind"
    }

    useEffect(() => {
        let draftsExist = false;
        if (pageLoaded) {
            if (addDroneASFAvailable && draftsASFStored?.length > 0) {
                let index = draftsASFStored.findIndex(f => String(f.formname).toLowerCase() === 'drone registration');
                if (index > -1) {
                    setDraftRPAs([
                        {
                            'recordid': draftsASFStored[index].recordid,
                            'formname': draftsASFStored[index].formname,
                            'lastModified': draftsASFStored[index].createdon
                        }
                    ]);
                    draftsExist = true;
                }
            }
            if (!addDroneASFAvailable) {
                setDraftRPAs([]);
            }
            if (!draftsExist) {
                startNewRegistration();
            }
            dispatch(addPageAlert({ level: "", title: "", message: "" }));
        }
    }, [pageLoaded]);

    useEffect(() => {
        const webappurl = B2CSettings.webappurlPortalApi;
        const accessToken = B2CSettings.accesstokenPortal;
        const webappurlF = B2CSettings.webappurlFormsApi;
        const droneTypes = featureRecDrone ? ['recreational', 'commercial'] : ['commercial'];

        //let parser = new UAParser();
        //setIphone(parser.getDevice().model === 'iPhone' && parseFloat(parser.getOS().version) >= 8.0);
        //setAndroid(parser.getOS().name === 'Android');

        if (isOrgPage) {
            axios.all([
                dispatch(getAppsOrganisation(webappurl, accessToken, organisationId)),
                dispatch(getDronesOrganisation(webappurlF, accessToken, organisationId, droneTypes)),
                dispatch(hasDraftsOrganisation(webappurlF, accessToken, organisationId)),
                dispatch(getOrganisationDetails(webappurl, accessToken, organisationId)),
                dispatch(getDroneCrmReferenceData(webappurlF, accessToken, ['Drone Weight Class 2021'], ['DRONE_WEIGHT_CLASS']))
            ])
                .then(axios.spread((appsres, dronesres, hasdraftsres, orgdetailsres, crmReferenceDatares) => {
                    if (appsres.type === FETCH_APPSORGANISATION_SUCCESS
                        && dronesres.type === FETCH_DRONESORGANISATION_SUCCESS
                        && hasdraftsres.type === HAS_DRAFTSORGANISATION_SUCCESS
                        && orgdetailsres.type === FETCH_ORGANISATIONDETAILS_SUCCESS
                        && crmReferenceDatares.type === FETCH_CRMREFERENCEDATA_SUCCESS
                    ) {
                        setPageLoaded(true);
                    }
                    else {
                        setPageLoaded(true);

                        let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                        let details = "Details: MRPAO.1";
                        dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                    }
                }))
                .catch(function (error) {
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: MRPAO.2";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                });
        } else {
            axios.all([
                dispatch(getAppsIndividual(webappurl, accessToken)),
                dispatch(getDronesIndividual(webappurlF, accessToken, droneTypes)),
                dispatch(hasDraftsIndividual(webappurlF, accessToken)),
                dispatch(getOrganisationDetails(webappurl, accessToken, organisationId)),
                dispatch(getDroneCrmReferenceData(webappurlF, accessToken, ['Drone Weight Class 2021'], ['DRONE_WEIGHT_CLASS']))
            ])
                .then(axios.spread((appsres, dronesres, hasdraftsres, orgdetailsres, crmReferenceDatares) => {
                    if (appsres.type === FETCH_APPSINDIVIDUAL_SUCCESS
                        && dronesres.type === FETCH_DRONESINDIVIDUAL_SUCCESS
                        && hasdraftsres.type === HAS_DRAFTSINDIVIDUAL_SUCCESS
                        && orgdetailsres.type === FETCH_ORGANISATIONDETAILS_SUCCESS
                        && crmReferenceDatares.type === FETCH_CRMREFERENCEDATA_SUCCESS
                    ) {
                        setPageLoaded(true);
                    }
                    else {
                        setPageLoaded(true);

                        let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                        let details = "Details: MRPAI.1";
                        dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                    }
                }))
                .catch(function () {
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: MRPAI.2";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                });
        }
    }, []);

    const manageComm = (index) => {
        history.push("/singlerpa?standalone=" + standalone + "&rpa=" + encodeURIComponent(btoa(JSON.stringify(index))) + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))));
    };

    const openSavedDraftASF = () => {
        let params = {
            'recordid': draftRPAs[0].recordid
        };
        let link = isOrgPage ? `/organisation/${organisationId}/drone-registration` : '/drone-registration';
        link += "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(params)));
        history.push(link);
    };

    const toggleModal = () => {
        setShowDelModal(!showDelModal);
    }

    const draftHandler = () => {
        if (addDroneASFAvailable) {
            return deleteSavedDraftASF(draftRPAs[0]);
        }
    }

    const showDeleteSavedDraftPrompt = () => {
        return (
            <CasaModal
                heading="Delete saved drone registration application"
                toggle={toggleModal}
                active={showDelModal}
                action={draftHandler}>
                <Fragment>
                    <p>Are you sure you want to delete your saved drone registration application?</p>
                    <p>This cannot be undone.</p>
                </Fragment>
            </CasaModal>
        )
    }

    const deleteSavedDraftASF = (data) => {

        setShowDelModal(false);
        setDeletingDraft(true);

        const accessToken = B2CSettings.accesstokenPortal;
        const webappurlF = B2CSettings.webappurlFormsApi;

        //show spinner
        axios.all([
            dispatch(deleteDraftASF(webappurlF, accessToken, data.recordid))
        ])
            .then(axios.spread((delres) => {
                if (delres.type === DELETE_DRAFT_SUCCESS) {
                    setTimeout(function () {
                        setDeletingDraft(false);
                        if (commArr.length === 0) {
                            let params = {
                                'draftdeleted': true
                            };
                            let link = isOrgPage ? `/organisation/${organisationId}/drone-registration` : '/drone-registration';
                            link += "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(params)));
                            history.replace(link);
                        }
                        else {
                            location.assign(isOrgPage ? "/forms/orgmanagerpa?draftdeleted=1&casaorgid=" + organisationId : "/forms/indmanagerpa?draftdeleted=1");
                        }
                    }, 10000);
                }
                else {
                    setDeletingDraft(false);
                    history.push("/error?code=MRPAI.5");
                }
            }))
            .catch(function () {
                setDeletingDraft(false);
                history.push("/error?code=MRPAI.6");
            });

    }

    const setupDrones = (commArr, commCols) => {
        commCols.push(
            {
                "label": 'Drone',
                "property": "name",
                "visible": true,
                "command": null,
                "commandLink": manageComm,
                "width": "30%",
                "type": "string"
            }
        );
        commCols.push(
            {
                "label": "Serial number / registration mark",
                "property": "serialNumber",
                "visible": true,
                "command": null,
                "commandLink": null,
                "width": "30%",
                "type": "string"
            }
        );
        commCols.push(
            {
                "label": "Expiry date",
                "property": "expirydate",
                "visible": true,
                "command": null,
                "commandLink": null,
                "width": "30%",
                "hasMsg": "msg",
                "hasMsglevel": "msglevel",
                "type": "date"
            }
        );
        commCols.push(
            {
                "label": null,
                "property": null,
                "visible": true,
                "command": "Manage",
                "commandLink": manageComm,
                "width": "10%",
                "type": null
            }
        );

        if (!dronesStored.items.value) return;

        for (let i = 0; i < dronesStored.items.value.length; i++) {
            let r = dronesStored.items.value[i];
            let type = r["reftype.casa_name"];
            let modelname = r["drone.casa_model"];
            let manufacturername = r["drone.casa_manufacturer"];
            let isRegisteredOverseas = r["drone.casa_isregisteredoverseas"] === 1 ? true : false;

            if (!manufacturername) {
                manufacturername = r["manufacturer.casa_name"];
            }
            if (!modelname) {
                modelname = r["model.casa_name"];
            }

            if (manufacturername === "Home built") {
                modelname = r["category.casa_name"];
            }

            let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
            let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');
            let todayStart = moment().startOf('day');

            let msg = '';
            let msglevel = '';

            let validUntilEnd = moment(r["casa_validuntil"], "YYYY-MM-DD").endOf('day');
            let validUntilStart = moment(r["casa_validuntil"], "YYYY-MM-DD").startOf('day');

            if (validUntilEnd < todayStart && expiredRPA < validUntilStart) {
                // expired
                msg = 'Expired';
                msglevel = 'error';
            }
            if (expiringRPA >= validUntilStart && validUntilStart >= todayStart) {
                // expiring
                msg = 'Expiring soon';
                msglevel = 'warning';
            }

            if (validUntilStart > expiredRPA) {
                commArr.push({
                    'droneRegistrationId': r["casa_droneregistrationid"],
                    'droneid': r["drone.casa_droneid"],
                    'name': modelname ? `${manufacturername} ${modelname}` : `${manufacturername} ${r["category.casa_name"]}`,
                    'manufacturer': manufacturername,
                    'model': modelname,
                    'serialNumber': r["drone.casa_serialnumber"],
                    'expirydate': moment(r["casa_validuntil"], "YYYY-MM-DD").format('DD MMM YYYY'),
                    'weightClass': '',
                    'regtype': type,
                    'msg': msg,
                    'msglevel': msglevel,
                    'isRegisteredOverseas': isRegisteredOverseas,
                    'manufacturedWeight': r["model.casa_droneweight"],
                    'suggestedWeightClassValue': r["droneWeightClass"],
                    'suggestedWeightClassCode': r["droneWeightClassCode"],
                    'category': r["category.casa_name"],
                    'weightClassList': getWeightClassList(r["droneWeightClassCode"], r["category.casa_name"], weightList)
                });
            }
        }
    }

    const getWeightClassList = (weightClassCode, category, weightClassList) => {
        let refWeightClassIndex = -1
        let slicedWeightList = weightClassList
        weightClassList.map((item, index) => {
            if (item.casa_code === weightClassCode && item.casa_code !== maxWeightClassCode) {
                refWeightClassIndex = index
            }
        })

        if (refWeightClassIndex >= 0) {
            slicedWeightList = weightClassList.slice(refWeightClassIndex + 1)
        }

        if (category === 'Airship' || weightClassCode === maxWeightClassCode) {
            slicedWeightList = []
        }

        return slicedWeightList
    }

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    const startNewRegistration = () => {
        if (commArr.length === 0) {
            let portalUrl = getPortalUrl("/dashorg", standalone, urlHome) + "&casaorgid=" + organisationId;

            let crumbs = [
                {
                    link: portalUrl + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
                    text: 'myCASA'
                }
            ];

            let crumb = {};
            if (commArr.length === 0) {
                crumb = {
                    text: 'Drone registration',
                    link: isOrgPage ? '/forms/orgmanagerpa?&standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
                        : '/forms/indmanagerpa?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
                }
            }
            else {
                crumb = {
                    text: 'Manage registered drones',
                    link: isOrgPage ? '/forms/orgmanagerpa?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
                        : '/forms/indmanagerpa?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
                }
            }
            crumbs.push(crumb);

            let params = {
                'organisationId': organisationId,
                'organisationArn': orgArn,
                'organisationName': orgName,
                'breadcrumbs': crumbs
            };

            let linkAdd = '';
            if (addDroneASFAvailable) {
                linkAdd = isOrgPage ? `/organisation/${organisationId}/drone-registration` : '/drone-registration';
                linkAdd += "?standalone=" + standalone;
                let params = window.location.search;
                let parsed = queryString.parse(params);
                if (parsed.dronedereged !== undefined && parsed.dronedereged === "1") {
                    linkAdd += "&dronedereged=1";
                }
            }
            history.replace(linkAdd);
        }
    }

    const dronesInProgMsg = () => {
        if (appsStored && appsStored.items && appsStored.items.inprogdrones && appsStored.items.inprogdrones.length > 0) {
            return (
                <Fragment>
                    <AUpageAlert as="info">
                        <h3>Drone registration application processing</h3>
                        <p>
                            Please note any drones (<abbr title="Remotely Piloted Aircraft">RPA</abbr>) you have recently registered may take a few minutes to appear below.
                        </p>
                    </AUpageAlert>
                    <br />
                </Fragment >
            );
        }
    }

    const dronesRenewalInProgMsg = () => {
        if (appsStored && appsStored.items && appsStored.items.inprogrenewaldrones && appsStored.items.inprogrenewaldrones.length > 0) {
            let found = commArr.filter(d => d.msg === "Expiring soon" || d.msg === "Expired").length;
            if (found > 0) {
                return (
                    <Fragment>
                        <AUpageAlert as="info">
                            <h3>Drone registration application processing</h3>
                            <p>
                                Please note we are still processing a drone registration application. Once complete you will see your renewed registration details below and an updated registration certificate
                            </p>
                        </AUpageAlert>
                        <br />
                    </Fragment >
                );
            }
            else {
                return null;
            }
        }
    }

    const dronesExpiredMsg = () => {
        let found = commArr.filter(d => d.msg === "Expired").length;
        if (found > 0) {
            return (
                <Fragment>
                    <AUpageAlert as="info">
                        <h3>Expired drone registration warning</h3>
                        <p>
                            Some of your drones&apos; registration has expired. These drones <b>cannot be legally operated</b> until they have been registered again. You can do this by selecting &apos;Renew drones&apos; below.
                            You have <b>30 days</b> after expiry to renew these drones before they are removed from myCASA.
                        </p>
                    </AUpageAlert>
                    <br />
                </Fragment>
            );
        }
        else {
            return null;
        }
    }

    const showDrones = (commArr, commCols, showAdd, userid, downloadSPSize) => {
        let expiryMsg = "";

        if (commArr.length > 0) {
            return isOrgPage ? (
                <RPAList
                    expiryMsg={expiryMsg}
                    commCols={commCols}
                    commArr={commArr}
                    showAdd={showAdd}
                    userid={userid}
                    organisationId={organisationId}
                    organisationArn={orgArn}
                    organisationName={name}
                    downloadSPSize={downloadSPSize}
                    draftRPAs={draftRPAs}
                />) : (<RPAList
                    expiryMsg={expiryMsg}
                    commCols={commCols}
                    commArr={commArr}
                    showAdd={showAdd}
                    userid={userid}
                    downloadSPSize={downloadSPSize}
                    draftRPAs={draftRPAs}
                />)
        }
    }

    const handleDrafts = () => {

        let found = commArr.filter(d => d.msg === "Expiring soon" || d.msg === "Expired").length;
        let draftHandler = null;
        if (addDroneASFAvailable) {
            draftHandler = openSavedDraftASF;
        }
        return (
            <div>
                {found > 0 ?
                    <AUpageAlert as="info">
                        <h3>You cannot add a drone registration while you have a saved drone registration application</h3>
                        <p>
                            Please complete or delete your application if you need to add a registration of any drones.
                        </p>
                    </AUpageAlert>
                    : null
                }

                {deletingDraft ? <CASASpinner message='Deleting saved application' /> : null}

                <AUcallout title="">
                    <h3>Saved drone registration application</h3>
                    <p>Saved: {moment(draftRPAs[0].lastModified, 'DD/MM/YYYY hh:mm:ss a Z').format("DD MMM YYYY")}</p>
                    <br />
                    <AUbutton id="resume" className="au-btn au-btn-large-width" onClick={draftHandler}>Resume saved application</AUbutton>
                    <br />
                    <br />
                    <AUbutton id="delete" className="au-btn au-btn-large-width btn-Hollow" onClick={toggleModal}>Delete saved application</AUbutton>
                </AUcallout>

                {showDeleteSavedDraftPrompt()}

            </div>
        )

    }

    const showSpinner = () => {
        if (showSpinnerFlag) {
            return (<CASASpinner message='Working. Please wait.....' />);
        }
    };

    let commArr = [];
    let commCols = [];
    let showAdd = true;

    const title = isOrgPage ? `Manage Registered Drones (Organisation)` : `Manage Registered Drones (Individual)`
    const id = isOrgPage ? `orgdronereg` : `inddronereg`

    // prevent access if no orgid or invalid organisationId or organisationId not related to user or no rpaid
    if (isOrgPage) {
        if (organisationId.length < 36) {
            organisationId = "";
        }

        if (organisationId === "") {
            history.push("/error?code=ORG.1&standalone=" + standalone);
        }

        if (participants && participants.items && !participants.items.isParticipant) {
            history.push("/error?code=ORG.2&standalone=" + standalone);
        }

        if (organisationdetails && organisationdetails.items && organisationdetails.items.value && organisationdetails.items.value.length === 0) {
            history.push("/error?code=ORG.3&standalone=" + standalone);
        }

        if (!isUUID(organisationId)) {
            history.push("/error?code=ORG.4&standalone=" + standalone);
        }
    }

    // prevent access if user does not have arn or has not applied for one
    let userHomePage = getUserHomePage(srarnsIndividual, null, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
        history.push(userHomePage);
        return null;
    }
    else {
        if (!pageLoaded) {
            return (
                <Fragment>
                    <MetaTags>
                        <title>{title}</title>
                    </MetaTags>

                    <Container show={true}>

                        <CASASpinner message="Working. Please wait....." />

                    </Container>

                </Fragment>
            )
        }
        else {
            setupDrones(commArr, commCols);

            const loc = isOrgPage ? getPortalUrl("/dashorg", standalone, urlHome) + "&casaorgid=" + organisationId + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))
                : getPortalUrl("/dashind", standalone, urlHome) + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));
            let items = [
                {
                    link: loc,
                    text: 'myCASA'
                }
            ];
            let showItems = true;
            let item = {};
            let text = "";
            if (commArr.length === 0) {
                text = 'Drone registration';
                item = {
                    text: text,
                }
                items.push(item);
            }
            else {
                text = 'Manage registered drones';
                item = {
                    text: text,
                }
                items.push(item);
            }

            if (draftRPAs && draftRPAs.length > 0) {
                return (
                    <Fragment>
                        <MetaTags>
                            <title>{title}</title>
                        </MetaTags>

                        <Heading
                            id={id}
                            text={text}
                            breadcrumbs={items}
                            showcrumbs={showItems}
                            showback={true} />

                        {handleDrafts()}

                        <div className="au-form-group">
                            <a className="au-direction-link au-direction-link--left" href={loc}>Return to myCASA</a>
                        </div>

                    </Fragment>
                );
            }
            else {
                let downloadSPSize = 0;
                let userid = "";

                if (isOrgPage) {
                    if (organisationdetails && organisationdetails.items && organisationdetails.items.value && organisationdetails.items.value[0].casa_droneregistrationurlfilesize !== undefined) {
                        downloadSPSize = Math.round(organisationdetails.items.value[0].casa_droneregistrationurlfilesize / 1024);
                        userid = user.contactid;
                    }
                } else {
                    if (user) {
                        if (user.casa_droneregistrationurlfilesize !== null) {
                            downloadSPSize = Math.round(user.casa_droneregistrationurlfilesize / 1024);
                            userid = user.contactid;
                        }
                    }
                }

                return (
                    <Fragment>
                        <MetaTags>
                            <title>{title}</title>
                        </MetaTags>

                        <Heading
                            id={id}
                            text={text}
                            breadcrumbs={items}
                            showcrumbs={showItems}
                            showback={true} />

                        {dronesInProgMsg()}

                        {dronesRenewalInProgMsg()}

                        {dronesExpiredMsg()}


                        {showSpinner()}

                        <br />

                        {showDrones(commArr, commCols, showAdd, userid, downloadSPSize)}

                        <div className="au-form-group">
                            <a className="au-direction-link au-direction-link--left" href={loc}>Return to myCASA</a>
                        </div>

                    </Fragment>
                );
            }
        }
    }
}

